import { Swiper, SwiperSlide } from 'swiper/react';
import swiper, { Navigation } from 'swiper';
import { ModuleContainer } from '../ModuleContainer';
import Card from './Card/Card';
import { M40ContentCardRow } from '~/lib/data-contract/auto-generated/api-model';
import Typography from '~/shared/components/Typography/Typography';
import styles from './M40ContentCardRow.module.scss';
import { useMemo, useRef, useState } from 'react';
import ChevronLeft from '~/icons/chevron-left.svg';
import ChevronRight from '~/icons/chevron.svg';
import clsx from 'clsx';
import 'swiper/css';
import 'swiper/css/navigation';

type M40ContentCardRowProps = M40ContentCardRow;

const CardRow = ({ title, contentCards, colorTheme }: M40ContentCardRowProps) => {
    const [swiperEl, setSwiperEl] = useState<swiper>();

    const prevRef = useRef<HTMLButtonElement>(null);
    const nextRef = useRef<HTMLButtonElement>(null);

    const renderItems = useMemo(() => {
        if (contentCards.length > 3) {
            return (
                <div className={styles.swiperContainer}>
                    <button className={styles.nav} ref={prevRef} aria-label="Previous">
                        <ChevronLeft />
                    </button>

                    <button
                        className={clsx(styles.nav, styles.next)}
                        ref={nextRef}
                        aria-label="Next"
                    >
                        <ChevronRight />
                    </button>

                    <Swiper
                        onSwiper={(swiper) => {
                            setSwiperEl(swiper);
                        }}
                        init={false}
                        spaceBetween={16}
                        slidesPerView={'auto'}
                        className={styles.swiper}
                        breakpoints={{
                            1440: {
                                slidesPerView: 4,
                            },
                        }}
                        navigation={{
                            prevEl: prevRef.current,
                            nextEl: nextRef.current,
                        }}
                        modules={[Navigation]}
                    >
                        {contentCards.map((item, index) => {
                            return (
                                <SwiperSlide key={index} className={styles.swiperSlide}>
                                    <Card {...item} isTextLimit />
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                </div>
            );
        }

        return (
            <div className={styles.list}>
                {contentCards.map((item, index) => {
                    return (
                        <div key={index} className={styles.item}>
                            <Card
                                {...item}
                                imageRatio={contentCards.length === 3 ? 'square' : 'rectangle'}
                            />
                        </div>
                    );
                })}
            </div>
        );
    }, [contentCards, swiperEl]);

    return (
        <ModuleContainer
            hasGutter
            className={styles.component}
            style={
                {
                    '--background-color': colorTheme.mainColor,
                    '--watermark-color': colorTheme.secondaryColor,
                    '--watermark-opacity': colorTheme.secondaryColorOpacity,
                    '--text-color': colorTheme.foregroundColor,
                } as React.CSSProperties
            }
        >
            {title && (
                <Typography variant="title-S" as="h2" className={styles.title}>
                    {title}
                </Typography>
            )}

            {renderItems}
        </ModuleContainer>
    );
};

export default CardRow;
